<section class="array-appender-wrapper" style="height:fit-content;">
  <section class="input-wrapper" *ngIf="showSelectionField">
    <gen-dynamic-form class="array-appender-form"
                      [ngClass]="formCssClasses"
                      [formConfig]="inputConfig"
                      [editMode]="widgetConfigPayload?.editMode"
                      [disabled]="widgetConfigPayload?.disabled"
                      [popupMode]="widgetConfigPayload?.popupMode"
                      (formChange)="updateSearchObject($event.form)"
                      [resetForm]="restForm"
                      [stayInFormMode]="true"
                      [additionalSearchValues]="additionalSearchValues"
                      [emitFormChangeEvenIfInvalid]="true"
    ></gen-dynamic-form>
    <gen-button
      *ngIf="widgetConfigPayload?.addButton"
      [text]="widgetConfigPayload?.addButton?.text"
      [type]="widgetConfigPayload?.addButton?.type"
      [iconClass]="widgetConfigPayload?.addButton?.iconClass"
      [disabled]="disabledStatus || btnDisabled"
      [buttonClass]="widgetConfigPayload?.addButton?.buttonClass"
      (click)="updateDestArray()"
    ></gen-button>
  </section>
  <gen-widget-item
    [value]="data"
    [item]="widgetConfigPayload"
    [componentToLoad]="widgetConfigPayload.componentToLoad"
    [formInstance]="widgetFormInstance"
    [disabled]="disabledStatus"
    [updateValue]="updateValue.bind(this)"
    (onAddControl)="addWidgetFormControl($event)"
  ></gen-widget-item>
</section>
